import { defaultState as state, mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

// TODO: replace with composables (5 days)
const assessmentStore = {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};

export default assessmentStore;
